import { render, staticRenderFns } from "./IndexActivityNew.vue?vue&type=template&id=28072b4a&scoped=true&"
import script from "./IndexActivityNew.vue?vue&type=script&lang=js&"
export * from "./IndexActivityNew.vue?vue&type=script&lang=js&"
import style0 from "./IndexActivityNew.vue?vue&type=style&index=0&id=28072b4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28072b4a",
  null
  
)

export default component.exports